import { get, patch, post, remove } from 'vio-libs';
export function getCrossConnections(organization) {
    return get(`cross-connections?organization=${organization}`);
}
export function getInterfaceCrossConnections(organization, deviceID, interfaceID) {
    return get(`cross-connections?organization=${organization}&device_id=${deviceID}&interface_id=${interfaceID}`);
}
export function getLockerCrossConnections(organization, deviceID) {
    return get(`cross-connections?organization=${organization}&device_id=${deviceID}`);
}
export function getSiteCrossConnections(organization, locationSlug) {
    return get(`cross-connections?organization=${organization}&location=${locationSlug}`);
}
export function postCrossConnection(organization, description, sourcePort, targetPort) {
    return post(`cross-connections?organization=${organization}`, {
        data: {
            description,
            source_port: sourcePort,
            target_port: targetPort
        }
    });
}
export function patchCrossConnection(organization, description, vcid) {
    return patch(`cross-connections?organization=${organization}`, {
        data: {
            description,
            vcid
        }
    });
}
export function removeCrossConnection(organization, vcid) {
    return remove(`cross-connections?organization=${organization}`, {
        data: {
            vcid
        }
    });
}
